import { EventEmitter, Injectable, Output } from '@angular/core';
import { subTextbausteine, TextbausteinId } from './textbaustein.model';

@Injectable()
export class TextbausteinFreigabetextService {
	@Output() textbausteinSelectedObservable = new EventEmitter<TextbausteinId>();

	textBausteinSelected(textbausteinId: TextbausteinId) {
		if (!subTextbausteine.includes(textbausteinId)) {
			this.textbausteinSelectedObservable.emit(textbausteinId);
		}
	}
}
